import { useState, createContext, useContext, useCallback, useMemo } from "react";
import { LANGUAGES } from "../i18n/translations";
import { apiTranslate } from "../api/client";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('solagroup_lang') || 'en');

  const t = useCallback((key) => apiTranslate(language, key), [language]);

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    localStorage.setItem('solagroup_lang', lang);
  }, []);

  const langContextValue = useMemo(() => ({ language, t, changeLanguage, languages: LANGUAGES }), [language, t, changeLanguage]);

  return (
    <LanguageContext.Provider value={langContextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
